import { msg } from "@lingui/core/macro";
import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { AuthPlaceholder } from "@/components/auth-placeholder";
import { NotificationsPage } from "@/features/social/components/notifications-page";
import { useI18n } from "@/providers/i18n-provider";

function NotificationsRoutePage() {
  const { t } = useI18n();
  return (
    <AuthPlaceholder
      title={t(msg`Tus notificaciones`)}
      description={t(msg`Inicia sesión para ver menciones, etiquetas y seguidores.`)}
    >
      <NotificationsPage />
    </AuthPlaceholder>
  );
}

export const notificationsRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/notifications",
  component: NotificationsRoutePage,
});
